module.exports = __webpack_public_path__ + "src/assets/img/print.d249a79f.svg";